// src/pages/RegisterPage.jsx
import RegistrationForm from "../components/common/RegistrationForm";
import "../styles/register/RegisterPage.css"; // nếu cần style riêng

function RegisterPage({ showToast }) {
  return (
    <div className="register-page">
      <RegistrationForm showToast={showToast} />
    </div>
  );
}

export default RegisterPage;
